import styled, { css } from 'styled-components';
import { white } from '../../../../design/colors/greyscale';
import { breakpointMedium } from '../../../../design/responsive/breakpoints';
import { pagePadding } from '../../../../templates/page/styles';
import { headerZindex } from '../../../zindex';
import { desktopHeaderContainerPadding, desktopHeaderHeight, headerHeight } from '../../data/measurements';

export const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${headerZindex};
  height: ${headerHeight};
  width: 100%;
  ${pagePadding};
  background-color: ${white};
  ${breakpointMedium(css`
    height: auto;
    padding-top: ${desktopHeaderContainerPadding};
    padding-bottom: ${desktopHeaderContainerPadding};
  `)}
`;

/**
 * Takes a callback that renders styles based on header height and renders those
 * styles for each breakpoint with the appropriate header height.
 */
export const generateStylesForHeaderHeightAtBreakpoints = (generateStyles: (headerHeight: string) => string) => css`
  ${generateStyles(headerHeight)}

  ${breakpointMedium(css`
    ${generateStyles(desktopHeaderHeight)}
  `)}
`;
